import { styled } from '@linaria/react';
import { IconButton } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { layersQuery } from '../../../../core/mapV2/queries';
import { layerVisibilitySet } from '../../../../core/mapV2/state';
import theme from '../../../../design/theme';
import { useAppDispatch, useAppSelector } from '../../../../types';
import { LAYER_ICONS } from './layerIcons';

const Strip = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 12px 0;
`;

// Content of the left panel when it is collapsed to its 56 px width: one icon per layer.
// Clicking an icon displays that layer (and hides the others), clicking the active one hides it.
export const LayerStrip: FC = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const layers = useAppSelector(layersQuery);

    return (
        <Strip data-testid="map-v2-layer-strip">
            {layers.map((layer) => {
                const Icon = LAYER_ICONS[layer.key];
                const title = layer.available
                    ? `${layer.label} · ${layer.indicator}`
                    : `${layer.label} · ${t('mapV2.layers.comingSoon')}`;

                return (
                    <IconButton
                        key={layer.key}
                        size="small"
                        disabled={!layer.available}
                        aria-label={title}
                        aria-pressed={layer.visible}
                        title={title}
                        onClick={() => dispatch(layerVisibilitySet({ layer: layer.key, visible: !layer.visible }))}
                        sx={{
                            backgroundColor: layer.visible ? theme.color.blue.primary : 'transparent',
                            color: layer.visible ? theme.color.white.main : theme.color.grey.light,
                            '&:hover': {
                                backgroundColor: layer.visible ? theme.color.blue.primary2 : undefined,
                            },
                        }}
                    >
                        <Icon fontSize="small" />
                    </IconButton>
                );
            })}
        </Strip>
    );
};
